<template>
	<div class="page">
		<van-icon name="arrow-left" class="return" size="28" @click="goBack" />
		<div class="logo">
			<img src="../assets/images/logo.png" alt="" />
		</div>
		<div class="sub-logo"></div>
		<div class="info">
			<img src="../assets/images/image.png" class="banner" alt="" style="width: 100%;
		max-width: 100%;
		margin: 0 auto;
		display: block;
		box-sizing: border-box;" />
			<!-- 白色边框 -->
			<div class="success-container">
				<div class="success-title">签到成功</div>
				<div class="pending-min-btn">请您移步武汉富力万达嘉华酒店（三楼大宴会厅）入座参会！</div>

				<div class="success-content">
					<div>您已成功签到！</div>
					<div class="seat-number">
						<div>您的座位号是：</div>
						<div style="color: #2196F3;">C区4排1座</div>
					</div>
				</div>
			</div>
		</div>
		<div class="apply" @click="goBack" >查看更多</div>
	</div>
</template>

<script setup>
import { useRouter } from 'vue-router';

const router = useRouter();
const goBack = () => {
	router.push({
		path: "/service",
	});
};
</script>

<style scoped>
.return {
	color: #fff;
	padding: 10px;
	border-radius: 5px;
	cursor: pointer;
}

.page {
	width: 100vw;
	height: 100vh;
	background: url("../assets/bg/background-3.jpg") 100% 100% no-repeat;
	background-size: cover;
}

.logo img {
	width: 30%;
	height: auto;
	display: block;
	padding-top: 10px;
	margin-left: 20px;
}

.sub-logo {
	width: 90%;
	height: 100px;
	background: url("../assets/images/sub-logo.png") no-repeat center center;
	background-size: contain;
	margin: auto;
}

.info {
	width: 82%;
	margin: auto;
	border-radius: 15px;
	margin-top: 20px;
	padding: 20px 10px;
	background-color: rgb(2 174 250 / 20%);
	box-sizing: border-box;
	overflow: hidden;


}

.info .banner {
	width: 100%;
	max-width: 100%;
	margin: 0 auto;
	display: block;
	box-sizing: border-box;
}

.text {
	color: #ffffff;
	text-align: center;
	margin: 5px 0;
}

.apply {
	width: 150px;
	height: 40px;
	/* height: auto; */
	background-image: url("../assets/images/apply.png");
	/* 替换为你的背景图片路径 */
	background-size: cover;
	background-position: center;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	margin: auto;
	margin-top: 20px;
	color: #071beb;
	font-weight: bold;


}

.success-container {
	background: white;
	border-radius: 0 0 20px 20px;
	padding: 10px 10px;
	text-align: center;
	max-width: 500px;
	margin: 0 auto;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);


}

.success-container .input-container {
	margin-bottom: 10px;
}

.success-title {
	font-size: 23px;
	text-align: center;
	font-weight: bold;
	margin-bottom: 10px;
}

.success-content {
	font-size: 16px;
	line-height: 1.8;
}

.highlight {
	color: #2196F3;
	font-weight: bold;
}

.seat-number {
	align-items: center;
	margin-top: 10px;
}

.pending-btn {
	background: #2196F3;
	color: white;
	border: none;
	padding: 5px 20px;
	border-radius: 15px;
	font-size: 15px;
	cursor: pointer;
}

input {
	width: 100%;
	height: 28px;
	background: #ffffff00;
	border: none;
	border: 1px solid #02aefa;
	border-radius: 5px;
	box-sizing: border-box;
	font-size: 14px;
}

.pending-min-btn {
	background: #2196F3;
	color: white;
	border: none;
	padding: 5px;
	border-radius: 15px;
	font-size: 16px;
	cursor: pointer;
	margin-bottom: 10px;
}
</style>
